module.exports = __webpack_public_path__ + "img/5f_r_goodsmile.59360ce8.jpg";